








import Vue from "vue";
import "@/plugins/typekit.js";

export default Vue.extend({
	name: "App",
});
